// ExpertsSlice_Store.ts
//
// Selection state for the Expert Finder profile panel. The inline experts
// table already carries everything the profile shows (channelData rows), so
// opening a profile stores the whole row — there is no detail fetch.

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Expert, ExpertsSliceState } from "./types/redux";
import { openDealDetail } from "./DealsTableSlice_Store";

const initialState: ExpertsSliceState = {
  selectedExpert: null,
  openSequence: 0,
};

const expertsSlice = createSlice({
  name: "experts",
  initialState,
  reducers: {
    openExpertProfile: (state, action: PayloadAction<Expert>) => {
      state.selectedExpert = action.payload;
      state.openSequence += 1;
    },
    closeExpertProfile: (state) => {
      state.selectedExpert = null;
    },
  },
  // An open deal and an open expert never share the RHS panel.
  extraReducers: (builder) => {
    builder.addCase(openDealDetail, (state) => {
      state.selectedExpert = null;
    });
  },
});

export const { openExpertProfile, closeExpertProfile } = expertsSlice.actions;

// --- Selectors ---

export const selectSelectedExpert = (state: { expertsSlice: ExpertsSliceState }): Expert | null =>
  state.expertsSlice.selectedExpert;

export const selectExpertOpenSequence = (state: { expertsSlice: ExpertsSliceState }): number =>
  state.expertsSlice.openSequence;

export default expertsSlice.reducer;
